import { NewBatchList } from './NewBatchList';
export default NewBatchList;
